import { Box, Breadcrumbs, Typography, Stack, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Chip } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { getAlerts, type AlertItem, type AlertSeverity } from '../api/rapoarte'

const SEVERITY_LABEL: Record<AlertSeverity, string> = { Critical: 'Critice', Warning: 'Avertismente', Info: 'Informative' }
const SEVERITY_COLOR: Record<AlertSeverity, 'error' | 'warning' | 'info'> = { Critical: 'error', Warning: 'warning', Info: 'info' }
const SEVERITY_ORDER: AlertSeverity[] = ['Critical', 'Warning', 'Info']

export default function AlertePage() {
  const navigate = useNavigate()
  const { data } = useQuery({ queryKey: ['rapoarte', 'alerte'], queryFn: getAlerts })

  const groups = SEVERITY_ORDER.map((sev) => ({
    severity: sev,
    items: (data ?? []).filter((a) => a.severity === sev),
  }))

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">Rapoarte</Typography>
        <Typography variant="inherit" color="text.primary">Alerte</Typography>
      </Breadcrumbs>
      <Typography variant="h2">Alerte</Typography>

      {data && data.length === 0 && (
        <Box sx={{ color: 'text.secondary' }}>Niciun eveniment activ care necesită atenție.</Box>
      )}

      {groups.filter((g) => g.items.length > 0).map((g) => (
        <Paper key={g.severity} variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" spacing={1} sx={{ mb: 1, alignItems: 'center' }}>
            <Chip size="small" label={SEVERITY_LABEL[g.severity]} color={SEVERITY_COLOR[g.severity]} variant="outlined" />
            <Typography variant="subtitle2">{g.items.length} eveniment(e)</Typography>
          </Stack>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Titlu</TableCell><TableCell>Detaliu</TableCell>
                <TableCell align="right">Cantitate / Sumă</TableCell><TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {g.items.map((a: AlertItem, i) => (
                <TableRow key={`${a.type}-${i}`}>
                  <TableCell>{a.title}</TableCell>
                  <TableCell>{a.detail}</TableCell>
                  <TableCell align="right">
                    {a.amount != null ? `${a.amount.toFixed(2).replace('.', ',')}${a.currency ? ` ${a.currency}` : ''}` : a.count != null ? a.count : '—'}
                  </TableCell>
                  <TableCell align="right">
                    <Button size="small" onClick={() => navigate(a.linkPath)}>Deschide</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ))}
    </Stack>
  )
}
